module.exports = __webpack_public_path__ + "static/media/Sinus.cabd4a30.webp";